import { render, staticRenderFns } from "./StockLinkedTransportOrdersTable.vue?vue&type=template&id=3d642e28&scoped=true"
import script from "./StockLinkedTransportOrdersTable.vue?vue&type=script&lang=js"
export * from "./StockLinkedTransportOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./StockLinkedTransportOrdersTable.vue?vue&type=style&index=0&id=3d642e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d642e28",
  null
  
)

export default component.exports